import React from 'react'
import { SuccessBanner, ErrorBanner } from '@chegg/fanta'
import { CancelIcon, colors } from '@chegg-ui/theme'
import * as Styled from './styled'
import { ToastComponentProps, ToastType } from './types'

export const TOAST_CONTAINER_ID = 'toast-container'
export const TOAST_CLEAR_OPEN_ID = 'toast-clear-open'

export const Toast: React.FC<ToastComponentProps> = ({
  message,
  toastType = ToastType.SUCCESS,
  position = 'bottomLeft',
  onClear,
}) => {
  const ref = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (message) {
      ref.current?.focus()
    }
  }, [message])

  if (!message) {
    return null
  }

  const Component = toastType === ToastType.SUCCESS ? SuccessBanner : ErrorBanner
  return (
    <Styled.ToastContainer
      position={position}
      data-test={TOAST_CONTAINER_ID}
      ref={ref}
      tabIndex={0}
    >
      <Component size="small">
        <Styled.ToastMessageContainer>
          <Styled.ToastMessage>{message}</Styled.ToastMessage>
          <Styled.CloseButton onClick={onClear} data-test={TOAST_CLEAR_OPEN_ID}>
            <CancelIcon size="small" color={colors.dark} />
          </Styled.CloseButton>
        </Styled.ToastMessageContainer>
      </Component>
    </Styled.ToastContainer>
  )
}
